import React, { Fragment, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import NewNavbar from "../../new-components/NewNavbar";
import NewPageHeader from "../../new-components/NewPageHeader";
import NewOverrides from "../../new-components/NewOverrides";
import NewDesignSystem from "../../new-components/NewDesignSystem";
import EventSingle from "../../components/EventDetails";
import NewFooter from "../../new-components/NewFooter";
import NewMadeWith from "../../new-components/NewMadeWith";
import NewScrollTop from "../../new-components/NewScrollTop";
import NewBackButton from "../../new-components/NewBackButton";
import "./style.css";

const EventDetailsFull = ({ eventId }) => {
  const { id: routeId } = useParams();
  const id = eventId || routeId;
  const userEmail = useSelector((state) => state.user?.user?.email);
  const isAdmin = Boolean(
    userEmail &&
    (userEmail === process.env.REACT_APP_ADMIN ||
      userEmail === process.env.REACT_APP_ARI_ADMIN)
  );
  const isConsultation = id === "consultanta";
  const isPublicConsultation = isConsultation && !isAdmin;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);

  return (
    <Fragment>
      <NewNavbar />
      <NewOverrides />
      <NewDesignSystem />

      <NewPageHeader compact={isPublicConsultation} />
      <main className={`registration-page ${
        isConsultation
          ? "consultation-registration-page"
          : id === "mostre"
            ? "samples-registration-page"
            : ""
      } ${isPublicConsultation ? "public-consultation-registration-page" : ""}`}>
        <EventSingle
          eventId={id}
          blLeft={"d-none"}
          blRight={"col-lg-10 offset-lg-1"}
        />
      </main>
      <NewBackButton />
      <NewFooter />
      <NewMadeWith />
      <NewScrollTop />
    </Fragment>
  );
};
export default EventDetailsFull;
